// extracted by mini-css-extract-plugin
export default {"table":"Tables_table__KmD4L","customTable":"Tables_customTable__-L4zv","MuiTableCell-sizeSmall":"Tables_MuiTableCell-sizeSmall__VFax+","actionsIcon":"Tables_actionsIcon__qezgf"};